'use client';

import { useState, useEffect } from 'react';



interface ChartData {
  month: string;
  portfolio: number;
  returns: number;
  investments: number;
}

const PerformanceChart = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [chartType, setChartType] = useState<'line' | 'area'>('area');
  const [timeRange, setTimeRange] = useState<'6m' | '1y' | 'all'>('6m');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const chartData: ChartData[] = [
    { month: 'Jul', portfolio: 8500, returns: 1200, investments: 7300 },
    { month: 'Aug', portfolio: 9200, returns: 1450, investments: 7750 },
    { month: 'Sep', portfolio: 9800, returns: 1680, investments: 8120 },
    { month: 'Oct', portfolio: 10500, returns: 1920, investments: 8580 },
    { month: 'Nov', portfolio: 11200, returns: 2180, investments: 9020 },
    { month: 'Dec', portfolio: 11800, returns: 2450, investments: 9350 },
    { month: 'Jan', portfolio: 12400, returns: 2720, investments: 9680 },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-card p-6 border border-border">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/3 mb-6"></div>
          <div className="h-80 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return null;
};

export default PerformanceChart;